import React from 'react';

/**
 * Helper function to highlight matching text in a query
 */
export const highlightMatch = (
    text: string,
    query: string,
    variant: 'default' | 'header' = 'default',
    menuColor: 'light' | 'dark' = 'dark'
) => {
    const lowerText = text.toLowerCase();
    const lowerQuery = query.toLowerCase();
    const index = lowerText.indexOf(lowerQuery);

    if (index !== -1) {
        const before = text.slice(0, index);
        const match = text.slice(index, index + query.length);
        const after = text.slice(index + query.length);
        return (
            <>
                <span
                    className={
                        variant === 'header' && menuColor === 'light'
                            ? 'py-0.5 text-dropdown text-gray-200'
                            : variant === 'header' && menuColor === 'dark'
                              ? 'py-0.5 text-dropdown text-gray-600'
                              : 'py-0.5 text-gray-400'
                    }
                >
                    {before}
                </span>
                <span
                    className={
                        variant === 'header' && menuColor === 'light'
                            ? 'py-0.5 text-dropdown text-white'
                            : variant === 'header' && menuColor === 'dark'
                              ? 'py-0.5 text-dropdown text-gray-800'
                              : 'py-0.5 text-gray-800'
                    }
                >
                    {match}
                </span>
                <span
                    className={
                        variant === 'header' && menuColor === 'light'
                            ? 'py-0.5 text-dropdown text-gray-200'
                            : variant === 'header' && menuColor === 'dark'
                              ? 'py-0.5 text-dropdown text-gray-600'
                              : 'py-0.5 text-gray-400'
                    }
                >
                    {after}
                </span>
            </>
        );
    }
    return (
        <span
            className={
                variant === 'header' && menuColor === 'light'
                    ? 'py-0.5 text-dropdown text-gray-200'
                    : variant === 'header' && menuColor === 'dark'
                      ? 'py-0.5 text-dropdown text-gray-600'
                      : 'py-0.5 text-gray-400'
            }
        >
            {text}
        </span>
    );
};
